import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgX = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <rect
      width={32}
      height={32}
      fill="#F18700"
      rx={16}
    />
    <path
      fill="#fff"
      d="M12.763 8H8l11.237 16H24zM17.52 14.773 23.477 8H22.07l-5.173 5.883z"
    />
    <path
      fill="#fff"
      d="M14.245 16.896 8 24h1.413l5.462-6.213z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgX);

export default ForwardRef;
